import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "notes-fixed-header" }
const _hoisted_2 = { class: "lesson-header-title" }
const _hoisted_3 = { class: "title-section" }
const _hoisted_4 = {
  class: "notes-scroll-container",
  ref: "scrollContainer"
}
const _hoisted_5 = { class: "body-section" }
const _hoisted_6 = {
  key: 0,
  class: "audio-list-section"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "audio-card-name" }
const _hoisted_9 = { class: "recording-prompt-content" }
const _hoisted_10 = {
  key: 0,
  src: "/assets/img/audio.gif",
  alt: "Recording",
  class: "recording-gif"
}
const _hoisted_11 = {
  key: 1,
  class: "recording-save-section"
}
const _hoisted_12 = {
  key: 1,
  class: "record-button-fixed"
}
const _hoisted_13 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_sub_menu_bar = _resolveComponent("sub-menu-bar")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, {
    fullscreen: "",
    "scroll-y": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["notes-modal", [_ctx.direction, { 'recording-active': _ctx.showRecordingPrompt }]])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.showLessonHeader)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "lesson-header",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openLesson && _ctx.openLesson(...args)))
              }, [
                (_ctx.lessonIconSrc)
                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 0,
                      src: _ctx.lessonIconSrc,
                      class: "lesson-header-icon"
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 1,
                      icon: _ctx.documentTextOutline,
                      class: "lesson-header-icon"
                    }, null, 8, ["icon"])),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.current.note_metadata.lessonTitle), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_sub_menu_bar, { buttons: _ctx.subMenuButtons }, null, 8, ["buttons"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ion_item, {
              lines: "none",
              class: "title-item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.title,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event)),
                  placeholder: _ctx.enterTitlePlaceholder,
                  "clear-input": "",
                  class: "title-input"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "divider" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ion_item, {
              lines: "none",
              class: "body-item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_textarea, {
                  ref: "bodyTextarea",
                  class: "body-textarea",
                  modelValue: _ctx.body,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.body) = $event)),
                  "auto-grow": true,
                  rows: 14,
                  placeholder: _ctx.enterTextPlaceholder
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            })
          ]),
          (!_ctx.isPwa)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audioResources, (clip) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: clip.Id,
                    class: "audio-card"
                  }, [
                    _createElementVNode("div", {
                      class: "audio-card-content",
                      onClick: ($event: any) => (_ctx.openClip(clip))
                    }, [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.playCircleOutline,
                        class: "audio-card-icon"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(clip.Name), 1)
                    ], 8, _hoisted_7),
                    _createVNode(_component_ion_icon, {
                      icon: _ctx.trash,
                      class: "audio-card-delete",
                      onClick: _withModifiers(($event: any) => (_ctx.deleteClip(clip)), ["stop"])
                    }, null, 8, ["icon", "onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 512),
        (_ctx.showRecordingPrompt)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "recording-prompt-overlay",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleOverlayClick && _ctx.handleOverlayClick(...args)))
            }, [
              _createElementVNode("div", {
                class: "recording-prompt",
                onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.isRecording)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                    : _createCommentVNode("", true),
                  (!_ctx.isRecording && _ctx.recordingStopped)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_ion_input, {
                          modelValue: _ctx.recordingTitle,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.recordingTitle) = $event)),
                          placeholder: _ctx.enterTitlePlaceholder,
                          class: "recording-title-input"
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("button", {
                          class: "recording-save-btn",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveRecording && _ctx.saveRecording(...args))),
                          "aria-label": 'Save recording'
                        }, [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.checkmark,
                            class: "recording-save-icon"
                          }, null, 8, ["icon"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isRecording && !_ctx.recordingStopped)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "recording-cancel-btn",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelRecording && _ctx.cancelRecording(...args)))
                      }, " Cancel "))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isRecording)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "recording-stop-btn",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleStopRecording && _ctx.handleStopRecording(...args))),
                      "aria-label": 'Stop recording'
                    }, [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.stopCircleOutline,
                        class: "recording-stop-icon"
                      }, null, 8, ["icon"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.shouldShowRecordButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "record-button-center",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleRecordClick && _ctx.handleRecordClick(...args))),
                "aria-label": _ctx.isRecording ? 'Stop recording' : 'Start recording'
              }, [
                _createVNode(_component_ion_icon, {
                  icon: _ctx.micCircleOutline,
                  class: "record-button-icon"
                }, null, 8, ["icon"])
              ], 8, _hoisted_13)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }))
}